<script setup>


import {computed} from "vue";

const props = defineProps({
    placeholder: String,
    modelValue: String | undefined,
    borderFocus: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false
    },
    type: {
        type: String,
        default: 'text'
    },
    fontSize: {
        type: String,
        default: 'sm'
    }
})
defineEmits(['update:modelValue', 'push', 'onFocus'])

const fontSizeClasses = computed(() => {
    return {
        'sm': 'text-sm',
        'base': 'text-base'
    }[props.fontSize]
})


</script>

<template>
    <div
        :class="{'!border-black dark:!border-slate-200': borderFocus && modelValue?.length > 0}"
        class="border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-dark-blue h-10 flex items-center px-4 w-full justify-between gap-3 transition-colors relative">
        <slot name="left-icon">
        </slot>
        <slot><input
            @input="$emit('update:modelValue', $event.target.value)"
            @keydown.enter="$emit('push')"
            @focus="$emit('onFocus')"
            :value="modelValue" :class="fontSizeClasses" class="border-0 dark:bg-dark-blue dark:text-slate-200 font-normal px-0 w-full h-full focus:ring-0 focus-visible:outline-0 placeholder:text-gray-400 dark:placeholder:text-slate-500"
            :type="type"
            :disabled="disabled"
            :placeholder="placeholder"></slot>
        <slot name="right-icon"></slot>
    </div>

</template>

<style scoped>

</style>
